import { LightningElement, api } from "lwc";
import { assignedNodes } from "common/slot";

export default class extends LightningElement {
  @api label: string = "";
  @api removeButtonTitle: string = "Remove";
  @api variant: "link" | "bare" | null = null;

  @api
  focus() {
    this.template.querySelector(".pill__remove")?.focus();
  }

  private titleWithFallback: string | null = null;

  private get className() {
    return ["pill", this.variant ? `pill--${this.variant}` : false]
      .filter(Boolean)
      .join(" ");
  }

  // Use slot node text as a title if the title attribute isn't provided
  private setTitle() {
    const slot = this.template.querySelector("slot") as HTMLSlotElement;

    this.titleWithFallback =
      this.title ||
      (slot
        ? assignedNodes(slot)
            .map((n) => n.textContent)
            .join("")
        : "");

    if (this.removeButtonTitle === "Remove") {
      this.removeButtonTitle = `Remove ${this.titleWithFallback}`;
    }
  }

  private handleRemove(e: MouseEvent) {
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent("remove"));
  }
}
